import { Button, Card, CardContent, Stack, Typography } from '@mui/material'
import { AddRounded as AddRoundedIcon } from '@mui/icons-material'

interface Props {
  title: string
  description?: string
  actionLabel?: string
  onAction?: () => void
}

export default function AccountEmptyCard(props: Props) {
  return <Card
    variant="dashed"
    sx={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <CardContent
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        p: {
          xs: 3,
          md: 4,
        },
      }}
    >
      <Stack spacing={1.5} alignItems="center" textAlign="center">
        <Typography variant="h3">{props.title}</Typography>
        {props.description ? <Typography variant="body2" color="text.secondary">
          {props.description}
        </Typography> : null}

        {props.actionLabel && props.onAction ? <Button
          variant="contained"
          color="accent"
          startIcon={<AddRoundedIcon />}
          onClick={props.onAction}
        >{props.actionLabel}</Button> : null}
      </Stack>
    </CardContent>
  </Card>
}
